import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const WarningFillDiamond = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 18 18" {...props}>
    <svg width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.25 7.94 10.06.75a1.5 1.5 0 0 0-2.12 0L.75 7.94a1.5 1.5 0 0 0 0 2.121l7.19 7.189a1.5 1.5 0 0 0 2.12 0l7.19-7.189a1.5 1.5 0 0 0 0-2.122ZM8.301 4.812a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-1.5 0v-4.5Zm.788 8.632h-.02a1.146 1.146 0 0 1-1.142-1.102 1.106 1.106 0 0 1 1.086-1.148h.02a1.146 1.146 0 0 1 1.142 1.103 1.106 1.106 0 0 1-1.086 1.147Z"
        fill={getColor(color, isColorInherited)}
      />
    </svg>
  </SvgIcon>
);
